module.exports = __webpack_public_path__ + "static/media/logo.06ef2568.png";